import React from 'react'
import FormControl from '@mui/material/FormControl'
import { RegionContentTag } from '../../swagger'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/system'
import CheckboxListCard from './CheckboxListCard'

export const CheckboxFormGroup = styled(FormControl)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1),
  justifyContent: 'flex-start',
})) as typeof FormControl

const ContentTagsCard: React.FC<{
  contentTags?: Required<RegionContentTag>[]
  isFieldDisabled: boolean
  handleContentTagsChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}> = ({ contentTags, isFieldDisabled, handleContentTagsChange }) => {
  const { t } = useTranslation()
  return (
    <CheckboxListCard
      isFieldDisabled={isFieldDisabled}
      handleCheckboxChange={handleContentTagsChange}
      headerId={'contentTagsCardHeader'}
      headerName={t('ContentTagsCard.Header.ContentTags', 'Content Tags')}
      checkboxItems={(contentTags ?? [])
        .filter((tag) => !!tag)
        .map(({ contentTagKey, enabledInRegion, tag }) => ({
          key: contentTagKey,
          checked: enabledInRegion,
          name: tag,
        }))}
    />
  )
}
export default ContentTagsCard
